import type { CustomerBlockContent } from '@/blocks/domain/types';
import type { RendererProps } from '../../domain/RendererContract';
import { FieldsBlockRender } from './FieldsBlockRender';

type Props = RendererProps<CustomerBlockContent>;

function CustomerRenderImpl({ content, style, context, accentColor, knownPaths }: Props) {
  return (
    <FieldsBlockRender
      fields={content.fields ?? []}
      style={style}
      context={context}
      accentColor={accentColor}
      knownPaths={knownPaths}
      ariaLabel="block-customer_block"
      sections={content.sections}
      columns={content.columns}
    />
  );
}

export const renderer = {
  Component: CustomerRenderImpl,
  flowBehavior: 'atomic' as const
};

export type { CustomerBlockContent };
